import "../src/Styles/App.css";
import Footer from "./component/Footer";
import Greetings from "./component/Greetings";
import Header from "./Layout/Header";
import LandingPage from "./pages/LandingPage";

function App() {
  return (
    <div className="App">
      <Header />
      <LandingPage />
      <Footer />
      <Greetings />
    </div>
  );
}

export default App;
